// extracted by mini-css-extract-plugin
export default {"paper":"Popover_paper__8lr1G"};